<!--
 * @Description: 
-->
<!--
 * @Description: 
-->
<template>
	<div>
		<page-header :tabIndex="9" :noWrite="noWrite" />
		<div class="about-box">
			<!-- <div class="banner-box"></div> -->
			 <img src="@/assets/images/about_banner.png" alt="" width="100%">
			<div class="desc-box">
				<div class="desc-title">
					公司简介
				</div>
				<div class="desc-img">
					<div class="left">
						<img style="margin-top: 45px;" src="../../assets/images/desc1.png" alt="" />
						<div class="text">
							深圳市极智数字科技有限公司（简称：极智数科）是一家AI驱动的建筑科技公司，公司依托超过百余个工程项目数字化交付的经验，结合AI、大数据、云计算等新一代信息技术，在智能设计、BIM报建交付、数字审查、数字协同、数字化交付研发多款产品与技术咨询服务体系，逐步形成工程建设项目数字化智能化的解决方案，为工程建设行业数字化转型赋能。
						</div>
						<img style="margin-top: 30px;" src="../../assets/images/desc2.png" alt="" />
						<div class="text">
							极智数科作为建筑行业的科技型企业，投入大量研发力量，研发了极智BIM智能设计软件、极智BIM云协同管理平台、极智BIMeta系列设计软件（快模、管综、管网设计、机电设计、报建交付、出图等模块）。未来，极智数科将通过BIM深化应用研究，将BIM技术普及应用于工程建设全生命周期中，真正实现工程建设全流程信息化；并以工程大数据为基础，利用先进的智能图形技术，结合互联网、物联网、云计算等新兴信息技术，为智慧城市建设提供服务。
						</div>
					</div>
					<div class="right"></div>
				</div>
			</div>
			<!-- <div class="show-img"></div> -->
			<img src="@/assets/images/about-show.png" alt="" width="100%">
			<!-- <div class="show-img2"></div> -->
			<img src="@/assets/images/about-show2.png" alt="" width="100%">
			<div class="desc-box">
				<div class="desc-title">联系我们</div>
				<div class="relavtie-box">
					<div class="map-box"></div>
					<div class="address-box flex flex-bt">
						<div class="box" >
							<div class="name">深圳</div>
							<div class="line" style="color: #333333;">深圳市极智数字科技有限公司</div>
							<div class="line">公司地址：深圳市南山区科技园讯美科技广场3号楼402</div>
							<div class="line">咨询热线：0755-86952970</div>
						</div>
						<div class="box" >
							<div class="name">洛阳</div>
							<div class="line" style="color: #333333;">智云数创(洛阳)数字科技有限公司</div>
							<div class="line">公司地址：河南省洛阳市涧西区国家大学科技园A-3栋6层</div>
							<div class="line">联系电话：18574006996</div>
						</div>
						<div class="box">
							<div class="name">销售渠道</div>
							<div class="line">全国：赵经理 13392833819</div>
							<div class="line">华东：李经理 15138765115</div>
							<div class="line">西南：赵经理 13027502077</div>
						</div>
					</div>					
				</div>
			</div>
		</div>
		<page-foot></page-foot>
	</div>
</template>
<script>
import pageHeader from "../../components/pageHeader.vue";
import pageFoot from "../../components/pageFoot.vue";
export default {
	name: "about",
	components: { pageHeader, pageFoot },

	data() {
		return {
			noWrite: true,
		};
	},
	created() {},
	mounted() {
		window.scrollTo({
			top: 0,
			behavior: "smooth", // 平滑滚动
		});
		window.addEventListener("scroll", this.handleScroll);
	},
	beforeDestroy() {
		window.removeEventListener("scroll", this.handleScroll);
	},
	methods: {
		handleScroll() {
			let top = document.documentElement.scrollTop;
			// console.log(top);
			if (top >= 100) {
				this.noWrite = false;
			} else {
				this.noWrite = true;
			}
		},
	},
};
</script>
<style lang="less" scoped>
.about-box {
}
.banner-box {
	background: url("../../assets/images/about_banner.png") center no-repeat;
	// background-size: cover;
	background-size: 100% 100%;
	height: 500px;
}
.desc-box {
	display: flex;
	flex-direction: column;
	align-items: center;
	.desc-title {
		color: #222222;
		font-weight: 700;
		font-size: 32px;
		margin-top: 80px;
	}
	.desc-img {
		margin-top: 50px;
		margin-bottom: 80px;
		display: flex;
		.right {
			background: url("../../assets/images/desc-img.png");
			height: 450px;
			width: 486px;
			margin-left: 47px;
		}
		.left {
			width: 400px;
			color: #3d3d3d;
			font-size: 14px;
			line-height: 22px;
		}
	}
}
.show-img {
	background: url("../../assets/images/about-show.png");
	height: 271px;
}
.show-img2 {
	background: url("../../assets/images/about-show2.png");
	height: 864px;
}
.relavtie-box {
	.map-box {
		margin-top: 50px;
		background: url("../../assets/images/about-map.png");
		width: 1200px;
		height: 260px;
	}
	.address-box {
	    width: 100%;
		padding: 0 20px;
		box-sizing: border-box;
		// justify-content: center;
		margin-bottom: 80px;
		.box {
			margin-top: 50px;
			.name {
				color: #333333;
				font-size: 18px;
				font-weight: 700;
			}
			.line {
				margin-top: 20px;
				font-size: 14px;
				color: #666666;
			}
		}
	}
}
</style>
